import { Link } from "react-router-dom";
import { useTranslation } from "../../../../i18n/useTranslation";

const Solutions = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="band-hero section text-center">
        <div className="eyebrow">{t("solutions.eyebrow")}</div>
        <h1>{t("solutions.headingLine1")}<br />{t("solutions.headingLine2")}</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{t("solutions.intro")}</p>
        </div>
      </div>

      <div className="band-a section">
        <div className="max-w-4xl mx-auto flex flex-col gap-6 px-5">
          {/* DeviceWorks */}
          <div className="card-ledger flex flex-col md:flex-row md:items-center gap-7">
            <img src={require("../../../../img/web/knowus/work/talent/lifecycle.png")} alt="" className="w-16 h-16" />
            <div className="flex-grow text-left">
              <h3>DeviceWorks</h3>
              <p className="mini">{t("solutions.dwBody")}</p>
            </div>
            <Link className="btn-brass shrink-0" to="/solutions/deviceworks">{t("solutions.dwButton")}</Link>
          </div>

          {/* iTrust.ID */}
          <div className="card-ledger flex flex-col md:flex-row md:items-center gap-7">
            <img src={require("../../../../img/web/market/itrust.png")} alt="" className="w-16 h-16" />
            <div className="flex-grow text-left">
              <h3>iTrust.ID</h3>
              <p className="mini">{t("solutions.itBody")}</p>
            </div>
            <Link className="btn-brass shrink-0" to="/solutions/itrust-id">{t("solutions.itButton")}</Link>
          </div>
        </div>
      </div>

      <div className="band-b section-tight text-center">
        <div className="eyebrow">{t("solutions.moreEyebrow")}</div>
        <h2>{t("solutions.moreHeading")}</h2>
        <p className="mini">{t("solutions.moreIntro")}</p>
      </div>
    </div>
  );
};

export default Solutions;
